import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from 'src/app/services/common/log.service';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/interfaces/user';
import { environment } from 'src/environments/environment';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pet-rehome-permission-request-modal',
  templateUrl: './pet-rehome-permission-request-modal.component.html',
  styleUrls: ['./pet-rehome-permission-request-modal.component.scss'],
})
export class PetRehomePermissionRequestModalComponent {
  @Input('modalRef') public modalRef: NgbModalRef;
  @Input('user') public user: User;
  @Input('chipNumber') public chipNumber: string;
  @Input('vetCode') public vetCode: string;

  public submissionComplete = false;
  public stripeDetailsLoading: boolean = false;
  public isPaymentFinished: boolean = false;
  public acceptTerms: boolean = false;
  public pricingPlans = environment.stripePlans;
  public planIdTOKPlusAlertFirstYear =
    this.pricingPlans.identiAlertTok;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private router: Router,
    private _logService: LogService,
    private checkoutService: CheckoutService
  ) {}

  public confirmAndProceedToCheckout() {
    this.stripeDetailsLoading = true;
    if (this.userService.isTOKFreeForUser(this.user)) {
      this.router.navigate(['/rehome-pet'], { queryParams: { chipNumber: this.chipNumber, vetCode: this.vetCode } });
      this.modalRef.close();
      return;
    }

    this.checkoutService
      .checkout([this.planIdTOKPlusAlertFirstYear], this.vetCode, this.chipNumber)
      .subscribe({
        next: () => {
          // Nothing should happen here because if checkout gets completed successfully, a redirect
          // will be triggered by stripe checkout
        },
        error: (err) => {
          this.stripeDetailsLoading = false;
          this.modalRef.dismiss();
          this._logService.error('An error occurred', err);
        }
      })
      .add(() => {
        this.stripeDetailsLoading = false;
        this.modalRef.close();
      });
  }
}
